import React from 'react';
import { CTAButton } from './CTAButton';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-6 md:pt-8 pb-10 px-4 text-center max-w-5xl mx-auto" data-id="element-80">
      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="text-3xl md:text-5xl font-black text-brand-text mb-4 leading-[1.1] tracking-tight max-w-3xl mx-auto text-balance" data-id="element-81">
        Risolvi un intero anno di lezioni di Yoga in soli{' '}
        <span className="italic text-brand-green" data-id="element-82">5 minuti</span>
      </motion.h1>

      <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.1
    }} className="text-sm md:text-lg text-brand-gray max-w-2xl mx-auto mb-4" data-id="element-83">
        Pianificazioni pronte, sequenze professionali e yoga terapeutico. Apri,
        scegli la lezione e insegni — senza improvvisare, senza domeniche perse
        a preparare.
      </motion.p>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.2
    }} className="relative w-full max-w-2xl mx-auto mb-6" data-id="element-84">
        <img src="https://cdn.magicpatterns.com/uploads/bAJ7jZ13PwpD34x2rdgAkK/ChatGPT_Image_9_jul_2026,_16_23_17-Photoroom.png" alt="Kit Yoga Pronta: 6 volumi annuali, monitor, tablet e telefono con le lezioni di yoga pronte all'uso." className="w-full h-auto max-h-[42vh] object-contain mx-auto" data-id="element-85" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.3
    }} data-id="element-86">
        <CTAButton onClick={scrollToPricing} className="mb-4" data-id="element-87">
          SÌ, VOGLIO RISPARMIARE IL MIO TEMPO
        </CTAButton>
        <p className="text-sm text-brand-gray font-medium" data-id="element-88">
          Pagamento sicuro &middot; Accesso immediato &middot; Garanzia di
          rimborso
        </p>
      </motion.div>
    </section>;
}